import { find, propEq } from 'ramda';

import { Classifier } from '../../../generated/model/models';
import { AutocompleteOption } from './Autocomplete';

export const mapSelectedAutocompleteOptions = (
  options: AutocompleteOption[],
  value?: string[],
): AutocompleteOption[] | undefined => {
  const selected: AutocompleteOption[] = [];

  if (options.length && value && value.length) {
    value.forEach((val) => {
      const option = find(propEq('value', val))(options) as AutocompleteOption;

      if (option) {
        selected.push(option);
      }
    });
  }

  return selected.length ? selected : undefined;
};

export function formatClassifiersToOptions(classiefiers: Classifier[]): AutocompleteOption[] {
  return classiefiers.reduce((options: AutocompleteOption[], classiefier: Classifier) => {
    if (classiefier.id && classiefier.name) {
      options.push({
        value: classiefier.id,
        label: classiefier.name,
      });
    }

    return options;
  }, []);
}
